<app-auth-layout>
  <div class="auth-form-content">
    @if (!isSubmitted) {
      <div class="auth-form-header">
        <div class="auth-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
          </svg>
          Password Reset
        </div>
        <h2 class="auth-title">Forgot your password?</h2>
        <p class="auth-subtitle">Enter your email address and we'll send you a link to reset your password.</p>
      </div>

      @if (errorMessage) {
        <vb-alert type="error" variant="soft" [showIcon]="true" [message]="errorMessage" class="block mb-4" />
      }

      <form (ngSubmit)="submitResetRequest()">
        <div class="auth-field">
          <vb-input
            id="email"
            name="email"
            type="email"
            label="Email Address"
            placeholder="name@company.com"
            [required]="true"
            [disabled]="isLoading"
            [(ngModel)]="email"
          />
        </div>

        <vb-button
          type="submit"
          variant="primary"
          size="md"
          [fullWidth]="true"
          [loading]="isLoading"
          [disabled]="isLoading">
          @if (isLoading) {
            Sending...
          } @else {
            Send Reset Link
          }
        </vb-button>
      </form>

      <p class="auth-back-link">
        Remember your password? <a routerLink="/">Back to Login</a>
      </p>
    } @else {
      <vb-alert
        type="success"
        variant="soft"
        [showIcon]="true"
        title="Check Your Email"
        [message]="'If an account exists with ' + email + ', you will receive a password reset link shortly.'"
        class="block mb-4"
      />
      <vb-button variant="primary" size="md" [fullWidth]="true" (click)="router.navigate(['/'])">
        Back to Login
      </vb-button>
    }

    <div class="auth-footer">
      <div class="auth-footer-links">
        <a routerLink="/terms-of-use">Terms of Use</a>
        <a routerLink="/privacy-policy">Privacy Policy</a>
        <a routerLink="/accessibility">Accessibility</a>
      </div>
      <p class="auth-footer-copyright">&copy; {{ currentYear }} Vertical Bridge REIT, LLC. All rights reserved.</p>
    </div>
  </div>
</app-auth-layout>
